export default {
    getHeaderFields: state => state.headerFields,
    getOccupationHealthHeaderFields: state => state.occupationHealthHeaderFields,
    getOccupationHealthDoctorHeaderFields: state => state.occupationHealthDoctorHeaderFields,
    getFormActions: state => state.formActions,
}
